import { TeamMember } from '@services/teams/types/team-member';
import { CallApi, handleJSONResponse } from './common';
import { NewTeamMember } from '@services/teams/types/new-team-member';

const callAPI = CallApi('teams');

export const get = async (labelId: string): Promise<TeamMember[]> => {
  const response = await callAPI(`/${labelId}`, 'GET');

  return await handleJSONResponse(response);
};

export const update = async (member: TeamMember): Promise<TeamMember> => {
  const response = await callAPI(`/`, 'PUT', member);

  return await handleJSONResponse(response);
};

export const remove = async (id: string, labelId: string) => {
  const response = await callAPI(`/remove/${id}/${labelId}`, 'DELETE');

  return await handleJSONResponse(response);
};

export const create = async (member: NewTeamMember): Promise<TeamMember> => {
  const response = await callAPI('/', 'POST', member);

  return await handleJSONResponse(response);
};
